import React, { useCallback, useRef } from "react";

import { Box, Card, Stack } from "@mui/material";

import SidebarView, { SidebarRef } from "../common/Sidebar";
import UsersList from "./components/UsersList";
import AddUserDialog from "./components/AddUserDialog";
import Headerbar from "../common/Headerbar";

export default function UsersView() {
  const [openAddUserDialog, setOpenAddUserDialog] = React.useState(false);

  const sidebarRef = useRef<SidebarRef>(null);
  const handleMobileMenuToggle = () => {
    sidebarRef.current?.toggleMobile();
  };

  // Handlers for opening and closing the dialog
  const openDialog = useCallback(() => setOpenAddUserDialog(true), []);
  const closeDialog = useCallback(() => setOpenAddUserDialog(false), []);

  return (
    <>
      <AddUserDialog open={openAddUserDialog} handleClose={closeDialog} />
      <SidebarView ref={sidebarRef} pageName="Users" />
      <Box
        component="main"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? theme.palette.grey[50]
              : theme.palette.grey[900],
          flexGrow: 1,
          height: "100vh",
          overflow: "auto",
        }}
      >
        <Headerbar
          pageName="Users"
          onMobileMenuClick={handleMobileMenuToggle}
        />

        <Card
          component={Stack}
          spacing={0}
          direction="column"
          sx={{
            position: "relative",
            px: 4,
            py: 4,
            borderRadius: 0,
            border: "none",
            backgroundColor: "transparent",
            boxShadow: "none",
            margin: 0,
            marginLeft: 6,
            marginRight: 6,
          }}
        >
          <UsersList handleOpenAddUserDialog={openDialog} />
        </Card>
      </Box>
    </>
  );
}
